<script lang="ts">
  import { QueryClient, QueryClientProvider } from "@tanstack/svelte-query";
  import Notifications from "svelte-notifications";

  import App from "./app.svelte";

  export let theme: "phone-numbers" | "default";
  export let options: string[];
  export let preselectedAreaCode: string;
  export let title: string;

  const queryClient = new QueryClient();
</script>

<QueryClientProvider client={queryClient}>
  <Notifications>
    <App {theme} {options} {preselectedAreaCode} {title} />
  </Notifications>
</QueryClientProvider>

<style lang="postcss" global>
  @import "reset.css";
  @import "global.css";
  @import "breakpoints.css";
  @import "atomic.css";
  @import "form.css";
  @import "button.css";
  @import "content-box.css";
  @import "popover.css";
  @import "animation.css";
  @import "notifications.css";
  @import "inline-link.css";
  @import "columns.css";
  @import "phone-numbers-theme.css";
</style>
